export const msalConfig = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_CLIENT_ID ?? '',
    authority: `${process.env.NEXT_PUBLIC_AUTHORITY_URL}/${process.env.NEXT_PUBLIC_SIGNIN}`,
    knownAuthorities: [process.env.NEXT_PUBLIC_AUTHORITY_DOMAIN ?? ''],
    redirectUri: process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI ?? '',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile'],
};
